module.exports = __webpack_public_path__ + "static/media/StartUp.02ca74cc.svg";